import { NavConfig } from 'app/components/app-common-views/sidebar-nav/nav-menus.constants';
import { NavConfigAcl } from 'app/store/auth/model/models';

export const buildAclList = (config: NavConfig) => {
  const acls = [];

  if (config.acl) {
    acls.push(config.acl);
  }

  const subAcls: NavConfigAcl[] = config.subMenuItems
    ? config.subMenuItems
        .map(subConfig => buildAclList(subConfig))
        .reduce((prev, current) => {
          return [...current, ...prev];
        }, [])
    : [];

  return [...acls, ...subAcls];
};
